<template>
  <BaseDialog
    :is-open="isOpen"
    @close="$emit('close')"
    type="basic"
    title="Möchtest du den Dialog abschliessen?"
  >
    <div
      v-if="uncoveredCount > 0"
      class="bg-secondary-container text-on-secondary-container rounded-medium mb-2 flex items-center gap-2 p-4"
    >
      <BaseIcon>target</BaseIcon>
      <p class="text-body-medium">
        {{ $t('dialog.conduct.uncoveredWarning', { count: uncoveredCount }) }}
      </p>
    </div>
    <div
      class="bg-tertiary-container text-on-tertiary-container rounded-medium flex items-center gap-2 p-4"
    >
      <BaseIcon>warning</BaseIcon>
      <p class="text-body-medium">{{ $t('dialog.conduct.irreversible') }}</p>
    </div>
    <template #confirm>
      <BaseTextButton color="filled" @click="$emit('conductDialog')" size="M">{{
        $t('dialog.conduct.action')
      }}</BaseTextButton>
    </template>
    <template #dismiss>
      <BaseTextButton @click="$emit('close')" size="M">{{ $t('common.cancel') }}</BaseTextButton>
    </template>
  </BaseDialog>
</template>

<script setup lang="ts">
  import BaseTextButton from '@/core/components/base/button/text-button/BaseTextButton.vue'
  import BaseDialog from '@/core/components/base/dialog/BaseDialog.vue'
  import BaseIcon from '@/core/components/base/icon/BaseIcon.vue'

  interface Props {
    isOpen: boolean
    uncoveredCount?: number
  }

  withDefaults(defineProps<Props>(), {
    uncoveredCount: 0,
  })

  defineEmits<{
    (e: 'close'): void
    (e: 'conductDialog'): void
  }>()
</script>
